import ModalContext from 'contexts/ModalContext'
import React, { useCallback, useContext } from 'react'
import LuxuryPlusLabel from './LuxuryPlusLabel'
import LuxPlusExclusiveInclusionsModal from './modals/LuxPlusExclusiveInclusionsModal'

interface Props {
  offer?: App.Offer | App.OfferSummary
}

export default function LuxPlusExclusiveInclusionsLabel({ offer }: Props) {
  const showModal = useContext(ModalContext)

  const toggleModal = useCallback(() => {
    showModal(<LuxPlusExclusiveInclusionsModal accommodationOffer={offer} />)
  }, [offer, showModal])

  return (
    <LuxuryPlusLabel type="extra-inclusions-with" onClick={toggleModal}/>
  )
}
